/**
 * Admin Landing Page
 * Redirects /admin to /admin/dashboard
 */

import { Navigate } from 'react-router-dom';

export function AdminLandingPage() {
    return <Navigate to="/admin/dashboard" replace />;
}
